import { useMemo } from "react"

import toast from "react-hot-toast"
import { Button, Card, Icon } from "semantic-ui-react"
import { FileChooserDropzoneTrigger } from "simplydo/react/components/Choosers/FileChooser/FileChooserDropzoneTrigger"
import { allowedVideoTypesList } from "simplydo/react/components/Choosers/FileChooser/uploadUtils"
import { VideoPlayer } from "simplydo/react/components/VideoPlayer"

import { VideoChooser } from "components/lib/Choosers"

import { BodySegment } from "./styles"

type VideoComponentProps = {
  ideaId: string
  video: string
  onRemove?: () => void
}

const VideoComponent = ({ ideaId, video, onRemove }: VideoComponentProps) => {
  const idea = useMemo(() => ({ _id: ideaId }), [ideaId])
  const memoisedPlayer = useMemo(
    () => <VideoPlayer src={video} style={{ marginTop: "20px" }} forType="idea" forItem={idea} />,
    [video, idea],
  )

  return (
    <Card.Group centered>
      <Card style={{ width: "80%" }}>
        <Card.Content style={{ color: "#808080" }}>
          <Icon name="film" />
          Uploaded video
        </Card.Content>
        <Card.Content textAlign="center">
          <Card.Header style={{ overflowWrap: "break-word" }}>{memoisedPlayer}</Card.Header>
        </Card.Content>
        {onRemove ? (
          <Card.Content extra>
            <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 10 }}>
              <Button basic size="small" icon="trash" onClick={onRemove} style={{ marginLeft: 0, marginRight: 0 }} />
            </div>
          </Card.Content>
        ) : null}
      </Card>
    </Card.Group>
  )
}

type VideoProps = {
  field: any
  ideaId: any
  fieldValue: any
  updateIdea: any
  isEditing: boolean
}

const Video = ({ field, ideaId, fieldValue = "", updateIdea, isEditing }: VideoProps) => {
  const onComplete = (_v, _name, videoSrc) => {
    // The video player doesn't respond well to updates, therefore we reset the video to null first
    updateIdea(null, ["templated", field.id], true)
    updateIdea(videoSrc, ["templated", field.id])
  }

  if (!isEditing) {
    if (fieldValue) {
      return <VideoComponent video={fieldValue} ideaId={ideaId} />
    }
    return null
  }

  if (fieldValue) {
    return (
      <BodySegment>
        <VideoComponent video={fieldValue} ideaId={ideaId} onRemove={() => updateIdea(null, ["templated", field.id])} />
      </BodySegment>
    )
  }

  return (
    <VideoChooser
      trigger={
        <FileChooserDropzoneTrigger
          forType="idea"
          forId={ideaId}
          accept={allowedVideoTypesList.join(",")}
          onComplete={onComplete}
          dropzoneProps={{
            title: "Upload a video",
            DropZoneComponent: BodySegment,
            defaultIcon: "film",
          }}
        />
      }
      forType="idea"
      forId={ideaId}
      onComplete={onComplete}
      onError={toast.error}
    />
  )
}

export default Video
